module.exports = __webpack_public_path__ + "img/博格华纳.png";